import gql from "graphql-tag";

export const REWARD_SUBSCRIPTION = gql`
subscription ruleRewardEligibleSubscription{
  ruleRewardEligibleSubscription{
    rewardEligible
    modelName
    pointEarned
    mutation
    pointsFor
  }
}
`

export const REWARD_OVERVIEW = gql`
query dashbordCardOverview($dateRange: [DateTime]) {
  total_points_earned: getTotalPoints
  recent_achivement: allRewardPoints(orderBy: ["-earnedAt"], first: 5) {
    edges {
      node {
        id
        points
        earnedAt
        rule {
          id
          category {
            id
            name
          }
        }
      }
    }
  }
  points_for_week: allRewardPoints(orderBy: ["-earnedAt"], earnedAt_Range: $dateRange) {
    edges {
      node {
        id
        points
      }
    }
  }
  overview_list: rewardOverview
}
`;


export const REWARD_HISTORY = gql`
query rewardHistory($endCursor: String) {
  allRewardPoints(orderBy: ["-earnedAt"], first:10, after:$endCursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        points
        earnedAt
        rule {
          id
          category {
            id
            name
          }
        }
      }
    }
  }
}
`;

export const REWARD_EARN_MORE = gql`
query EarnMoreActions {
  earnMore {
    id
    path
    category {
      id
      name
    }
    points
  }
}
`;

export const REWARD_REDEEM = gql`
query getAvailableRewards {
  totalRewardPoints: getTotalPoints
  rewardList:getAvailableRewards{
    reward{
      id
      name
      pointsRequired
    }
    status
  }
}
`;

export const REWARD_REDEEM_MUTATION = gql`
mutation createRedeemPoint($userId: Int!, $orgId: Int!, $pointsRedeemed: Int!, $rewardId: Int!) {
  createRedeemPoint(userId: $userId, orgId: $orgId, pointsRedeemed: $pointsRedeemed, rewardId: $rewardId) {
    redeemPoint {
      id
      pointsRedeemed
      redeemedAt
      user {
        id
      }
      org {
        id
      }
      reward {
        id
      }
      coupon {
        id
      }
    }
  }
}
`